// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PatientInfo_patientForm__Jo\\+zh {
  margin-top: 3rem;
}
.PatientInfo_patientForm__row__2Go3U {
  display: flex;
  gap: 1.5rem;
  margin-bottom: 1.5rem;
}
.PatientInfo_patientForm__group__8Rh6W {
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
}
.PatientInfo_patientForm__label__D\\+nsA {
  font-size: 0.8rem;
  font-weight: 400;
  color: #274760;
  margin-bottom: 0.5rem;
}
.PatientInfo_patientForm__input__Vnd3o {
  padding: 0.7rem 1rem;
  border: 1px solid #d1d5db;
  border-radius: 12px;
  font-size: 1rem;
  color: #1e293b;
  transition: border-color 0.2s;
}
.PatientInfo_patientForm__input__Vnd3o:focus {
  outline: none;
  border-color: #3D7EBE;
  box-shadow: 0 0 0 2px rgba(61, 126, 190, 0.2);
}
.PatientInfo_patientForm__input__Vnd3o::placeholder {
  opacity: 0.5;
  font-weight: 400;
  font-size: 0.9rem;
}
.PatientInfo_patientForm__fileDropzone__zcKrH {
  border: 2px dashed #d1d5db;
  border-radius: 12px;
  padding: 2rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  cursor: pointer;
  transition: border-color 0.2s, background-color 0.2s;
  overflow-wrap: anywhere;
}
.PatientInfo_patientForm__fileDropzone__zcKrH:hover {
  border-color: #3D7EBE;
}
.PatientInfo_patientForm__Jo\\+zh .PatientInfo_file-dropzone__icon__ha2N0 {
  color: #3D7EBE;
  font-size: 2.5rem !important;
  margin-bottom: 0.5rem;
  width: 44px;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #F5F5F5;
  border-radius: 50%;
}
.PatientInfo_patientForm__Jo\\+zh .PatientInfo_file-dropzone__text__5-uJD {
  font-weight: 400;
  color: #353535;
  margin-bottom: 0;
}
.PatientInfo_patientForm__Jo\\+zh .PatientInfo_file-dropzone__text__5-uJD span {
  text-decoration: auto;
  color: #577399;
  font-weight: 400;
}
.PatientInfo_patientForm__Jo\\+zh .PatientInfo_file-dropzone__hint__YhHAv {
  font-size: 0.8rem;
  color: #353535;
  margin-top: 0;
}
.PatientInfo_patientForm__actions__pMgUq {
  display: flex;
  justify-content: flex-end;
}
.PatientInfo_patientForm__button__aZbHe {
  background: #FE5F55;
  color: #ffffff;
  border: none;
  padding: 0.6rem 2.6rem;
  font-size: 0.9rem;
  font-weight: 400;
  border-radius: 6px;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  margin-top: 2rem;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}
.PatientInfo_patientForm__button__aZbHe:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(61, 126, 190, 0.3);
}
@media (max-width: 990px) {
  .PatientInfo_patientForm__row__2Go3U {
    display: flow;
  }
}
@media (max-width: 767px) {
  .PatientInfo_patientForm__Jo\\+zh {
    margin-top: 2rem;
  }
  .PatientInfo_patientForm__row__2Go3U {
    flex-direction: column;
    margin-bottom: 0;
    gap: 0;
  }
  .PatientInfo_patientForm__group__8Rh6W {
    margin-bottom: 1.5rem;
  }
  .PatientInfo_patientForm__button__aZbHe {
    width: 100%;
    padding: 0.8rem;
    justify-content: center;
    font-size: 1rem;
  }
}

.PatientInfo_loading-form-modal__gtb3I {
  position: absolute !important;
  inset: 0;
  background-color: rgba(255, 255, 255, 0.74);
  z-index: 10;
}

.PatientInfo_patientForm__switch__ubF8I {
  display: flex;
  align-items: center;
}

.PatientInfo_patientForm__switch-label__oAQsv {
  font-size: 0.9rem;
  color: #1e293b;
  cursor: pointer;
  margin-bottom: 0;
  margin-right: 1rem;
}

.PatientInfo_consult-price-container__xTiVi {
  margin-bottom: 20px;
}

.PatientInfo_consult-price-box__MZG07 {
  display: flex;
  align-items: center;
  background-color: #f0fdf4;
  border: 1px solid #dcfce7;
  border-radius: 8px;
  padding: 12px 16px;
  gap: 12px;
}

.PatientInfo_price-icon-wrapper__VL4aS {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: #dcfce7;
  color: #166534;
  border-radius: 50%;
}

.PatientInfo_price-details__sbSWj {
  display: flex;
  flex-direction: column;
}

.PatientInfo_price-label__JnmNU {
  font-size: 0.85rem;
  color: #4b5563;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.PatientInfo_price-amount__xwyvu {
  font-size: 1.25rem;
  color: #166534;
  font-weight: 700;
  line-height: 1.2;
}

.PatientInfo_modalGrid__pVI-l {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
@media (min-width: 990px) {
  .PatientInfo_modalGrid__pVI-l {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 2rem;
    align-items: start;
  }
}

.PatientInfo_modalColumn__6lhM4 {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  height: 100%;
}

.PatientInfo_modalFullWidth__o3zEZ {
  grid-column: 1/-1;
  width: 100%;
  margin-top: 1rem;
}

.PatientInfo_modalActions__z6a3C {
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
}
@media (min-width: 990px) {
  .PatientInfo_modalActions__z6a3C {
    margin-top: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/BookingPage/Step/PatientInfo/PatientInfo.module.scss"],"names":[],"mappings":"AAQA;EACE,gBAAA;AAPF;AASE;EACE,aAAA;EACA,WAAA;EACA,qBAAA;AAPJ;AAUE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AARJ;AAWE;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AATJ;AAYE;EACE,oBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAjCQ;EAkCR,6BAAA;AAVJ;AAYI;EACE,aAAA;EACA,qBAxCU;EAyCV,6CAAA;AAVN;AAaI;EACE,YAAA;EACA,gBAAA;EACA,iBAAA;AAXN;AAeE;EACE,0BAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAxDU;EAyDV,eAAA;EACA,oDAAA;EACA,uBAAA;AAbJ;AAeI;EACE,qBAlEU;AAqDhB;AAkBI;EACE,cAxEU;EAyEV,4BAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AAhBN;AAmBI;EACE,gBAAA;EACA,cAAA;EACA,gBAAA;AAjBN;AAmBM;EACE,qBAAA;EACA,cAAA;EACA,gBAAA;AAjBR;AAqBI;EACE,iBAAA;EACA,cAAA;EACA,aAAA;AAnBN;AAuBE;EACE,aAAA;EACA,yBAAA;AArBJ;AAwBE;EACE,mBAAA;EACA,cA1GU;EA2GV,YAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,2CAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;AAtBJ;AAwBI;EACE,2BAAA;EACA,8CAAA;AAtBN;AA4BE;EACE;IACE,aAAA;EA1BJ;AACF;AA6BE;EAjIF;IAkII,gBAAA;EA1BF;EA4BE;IACE,sBAAA;IACA,gBAAA;IACA,MAAA;EA1BJ;EA6BE;IACE,qBAAA;EA3BJ;EA8BE;IACE,WAAA;IACA,eAAA;IACA,uBAAA;IACA,eAAA;EA5BJ;AACF;;AAgCA;EACE,6BAAA;EACA,QAAA;EACA,2CAAA;EACA,WAAA;AA7BF;;AAgCA;EACE,aAAA;EACA,mBAAA;AA7BF;;AAgCA;EACE,iBAAA;EACA,cA3KU;EA4KV,eAAA;EACA,gBAAA;EACA,kBAAA;AA7BF;;AAiCA;EACE,mBAAA;AA9BF;;AAiCA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;AA9BF;;AAiCA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;AA9BF;;AAiCA;EACE,aAAA;EACA,sBAAA;AA9BF;;AAiCA;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;AA9BF;;AAiCA;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AA9BF;;AAiCA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA9BF;AAgCE;EALF;IAMI,aAAA;IACA,8BAAA;IACA,SAAA;IACA,kBAAA;EA7BF;AACF;;AAgCA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;AA7BF;;AAgCA;EACE,iBAAA;EACA,WAAA;EACA,gBAAA;AA7BF;;AAgCA;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;AA7BF;AA+BE;EALF;IAMI,aAAA;EA5BF;AACF","sourcesContent":["$primary-color: #3D7EBE;\n$primary-color-dark: #495867;\n$text-dark: #1e293b;\n$border-color: #d1d5db;\n$white-color: #ffffff;\n$breakpoint-md: 990px;\n$breakpoint-xs: 767px;\n\n.patientForm {\n  margin-top: 3rem;\n\n  &__row {\n    display: flex;\n    gap: 1.5rem;\n    margin-bottom: 1.5rem;\n  }\n\n  &__group {\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 1rem;\n  }\n\n  &__label {\n    font-size: 0.8rem;\n    font-weight: 400;\n    color: #274760;\n    margin-bottom: 0.5rem;\n  }\n\n  &__input {\n    padding: 0.7rem 1rem;\n    border: 1px solid $border-color;\n    border-radius: 12px;\n    font-size: 1rem;\n    color: $text-dark;\n    transition: border-color 0.2s;\n\n    &:focus {\n      outline: none;\n      border-color: $primary-color;\n      box-shadow: 0 0 0 2px rgba($primary-color, 0.2);\n    }\n\n    &::placeholder {\n      opacity: 0.5;\n      font-weight: 400;\n      font-size: 0.9rem;\n    }\n  }\n\n  &__fileDropzone {\n    border: 2px dashed $border-color;\n    border-radius: 12px;\n    padding: 2rem;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    background-color: $white-color;\n    cursor: pointer;\n    transition: border-color 0.2s, background-color 0.2s;\n    overflow-wrap: anywhere;\n\n    &:hover {\n      border-color: $primary-color;\n    }\n  }\n\n  .file-dropzone {\n    &__icon {\n      color: $primary-color;\n      font-size: 2.5rem !important;\n      margin-bottom: 0.5rem;\n      width: 44px;\n      height: 44px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      background: #F5F5F5;\n      border-radius: 50%;\n    }\n\n    &__text {\n      font-weight: 400;\n      color: #353535;\n      margin-bottom: 0;\n\n      span {\n        text-decoration: auto;\n        color: #577399;\n        font-weight: 400;\n      }\n    }\n\n    &__hint {\n      font-size: 0.8rem;\n      color: #353535;\n      margin-top: 0;\n    }\n  }\n\n  &__actions {\n    display: flex;\n    justify-content: flex-end;\n  }\n\n  &__button {\n    background: #FE5F55;\n    color: $white-color;\n    border: none;\n    padding: 0.6rem 2.6rem;\n    font-size: 0.9rem;\n    font-weight: 400;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: transform 0.2s, box-shadow 0.2s;\n    margin-top: 2rem;\n    display: inline-flex;\n    align-items: center;\n    gap: 0.5rem;\n\n    &:hover {\n      transform: translateY(-2px);\n      box-shadow: 0 4px 15px rgba($primary-color, 0.3);\n    }\n  }\n\n\n\n  @media (max-width: $breakpoint-md) {\n    &__row {\n      display: flow;\n    }\n  }\n\n  @media (max-width: $breakpoint-xs) {\n    margin-top: 2rem;\n\n    &__row {\n      flex-direction: column;\n      margin-bottom: 0;\n      gap: 0;\n    }\n\n    &__group {\n      margin-bottom: 1.5rem;\n    }\n\n    &__button {\n      width: 100%;\n      padding: 0.8rem;\n      justify-content: center;\n      font-size: 1rem;\n    }\n  }\n}\n\n.loading-form-modal {\n  position: absolute !important;\n  inset: 0;\n  background-color: rgb(255 255 255 / 74%);\n  z-index: 10;\n}\n\n.patientForm__switch {\n  display: flex;\n  align-items: center;\n}\n\n.patientForm__switch-label {\n  font-size: 0.9rem;\n  color: $text-dark;\n  cursor: pointer;\n  margin-bottom: 0;\n  margin-right: 1rem;\n}\n\n\n.consult-price-container {\n  margin-bottom: 20px;\n}\n\n.consult-price-box {\n  display: flex;\n  align-items: center;\n  background-color: #f0fdf4;\n  border: 1px solid #dcfce7;\n  border-radius: 8px;\n  padding: 12px 16px;\n  gap: 12px;\n}\n\n.price-icon-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  background-color: #dcfce7;\n  color: #166534;\n  border-radius: 50%;\n}\n\n.price-details {\n  display: flex;\n  flex-direction: column;\n}\n\n.price-label {\n  font-size: 0.85rem;\n  color: #4b5563;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.price-amount {\n  font-size: 1.25rem;\n  color: #166534;\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n.modalGrid {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n\n  @media (min-width: $breakpoint-md) {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 2rem;\n    align-items: start;\n  }\n}\n\n.modalColumn {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  height: 100%;\n}\n\n.modalFullWidth {\n  grid-column: 1 / -1;\n  width: 100%;\n  margin-top: 1rem;\n}\n\n.modalActions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 1rem;\n\n  @media (min-width: $breakpoint-md) {\n    margin-top: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"patientForm": `PatientInfo_patientForm__Jo+zh`,
	"patientForm__row": `PatientInfo_patientForm__row__2Go3U`,
	"patientForm__group": `PatientInfo_patientForm__group__8Rh6W`,
	"patientForm__label": `PatientInfo_patientForm__label__D+nsA`,
	"patientForm__input": `PatientInfo_patientForm__input__Vnd3o`,
	"patientForm__fileDropzone": `PatientInfo_patientForm__fileDropzone__zcKrH`,
	"file-dropzone__icon": `PatientInfo_file-dropzone__icon__ha2N0`,
	"file-dropzone__text": `PatientInfo_file-dropzone__text__5-uJD`,
	"file-dropzone__hint": `PatientInfo_file-dropzone__hint__YhHAv`,
	"patientForm__actions": `PatientInfo_patientForm__actions__pMgUq`,
	"patientForm__button": `PatientInfo_patientForm__button__aZbHe`,
	"loading-form-modal": `PatientInfo_loading-form-modal__gtb3I`,
	"patientForm__switch": `PatientInfo_patientForm__switch__ubF8I`,
	"patientForm__switch-label": `PatientInfo_patientForm__switch-label__oAQsv`,
	"consult-price-container": `PatientInfo_consult-price-container__xTiVi`,
	"consult-price-box": `PatientInfo_consult-price-box__MZG07`,
	"price-icon-wrapper": `PatientInfo_price-icon-wrapper__VL4aS`,
	"price-details": `PatientInfo_price-details__sbSWj`,
	"price-label": `PatientInfo_price-label__JnmNU`,
	"price-amount": `PatientInfo_price-amount__xwyvu`,
	"modalGrid": `PatientInfo_modalGrid__pVI-l`,
	"modalColumn": `PatientInfo_modalColumn__6lhM4`,
	"modalFullWidth": `PatientInfo_modalFullWidth__o3zEZ`,
	"modalActions": `PatientInfo_modalActions__z6a3C`
};
export default ___CSS_LOADER_EXPORT___;
